import PropTypes from 'prop-types';
// material
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object
};

export default function Logo({ sx, w=90, h=60 }) {
  return <Box component="img" src="/static/logo.svg" sx={{ width: w, height: h, ...sx }} />;
}
